export default __webpack_public_path__ + "static/media/guiavet.40a2b710.gif";